/**
 * @deprecated The TIL configuration editor in Catalyst Portal has been retired.
 * TIL template and game configuration functionality is maintained directly within the TIL Server unity app.
 * Note: buildDefaultTilConfig is preserved for backwards-compatible initial payload creation.
 * Ref: https://dev.azure.com/catalyst-global/TIL%20The%20Infinite%20Loop/_workitems/edit/11620
 */
import { uuid } from '../types/common-helper';
import {
  TilGameConfig,
  TilLock,
  TilLockLevel,
  TilRoom
} from '../types/til-template';

export const TIL_LOGO_RESOLUTION_NONE = 6;

export const TIL_LOGO_RESOLUTION_LABELS: Record<number, string> = {
  0: 'Computer Screen',
  1: 'Vertical Frame',
  2: 'Horizontal Frame',
  3: 'Wide Vertical Frame',
  4: 'Wide Horizontal Frame',
  5: 'TV Screen',
  6: 'No Logo'
};

export interface TilPuzzle {
  id: number;
  name: string;
}

export const TIL_PUZZLES: TilPuzzle[] = [
  { id: 0, name: 'Access Code — Easy' },
  { id: 2, name: 'Access Code — Hard' },
  { id: 3, name: 'Cards And Colors — Easy' },
  { id: 4, name: 'Cards And Colors — Medium' },
  { id: 6, name: 'Semaphore — Easy' },
  { id: 7, name: 'Semaphore — Hard' },
  { id: 8, name: 'Emoji Numbers — Easy' },
  { id: 9, name: 'Emoji Numbers — Hard' },
  { id: 11, name: 'Cubes Enigma — Easy' },
  { id: 13, name: 'Cubes Enigma — Hard' },
  { id: 14, name: 'Coloured Words' },
  { id: 15, name: '(Empty)' }
];

export const TIL_PUZZLE_EMPTY = 15;

export interface TilRoomDefinition {
  idRoom: number;
  logoResolution: number;
}

export interface TilDoorDefinition {
  idDoor: number;
  idRoom: number;
  level1Slots: number;
  level2Slots: number;
}

export interface TilMapDefinition {
  idMap: number;
  label: string;
  rooms: TilRoomDefinition[];
  doors: TilDoorDefinition[];
}

export const TIL_MAPS: TilMapDefinition[] = [
  {
    idMap: 1,
    label: 'Infinite Map',
    rooms: [
      { idRoom: 0, logoResolution: 4 },
      { idRoom: 1, logoResolution: 6 },
      { idRoom: 2, logoResolution: 4 },
      { idRoom: 3, logoResolution: 6 },
      { idRoom: 4, logoResolution: 1 },
      { idRoom: 5, logoResolution: 5 },
      { idRoom: 6, logoResolution: 1 },
      { idRoom: 7, logoResolution: 6 },
      { idRoom: 8, logoResolution: 6 }
    ],
    doors: [
      { idDoor: 0, idRoom: 0, level1Slots: 0, level2Slots: 3 },
      { idDoor: 1, idRoom: 1, level1Slots: 3, level2Slots: 3 },
      { idDoor: 2, idRoom: 2, level1Slots: 3, level2Slots: 3 },
      { idDoor: 3, idRoom: 2, level1Slots: 3, level2Slots: 3 },
      { idDoor: 4, idRoom: 3, level1Slots: 3, level2Slots: 3 },
      { idDoor: 5, idRoom: 2, level1Slots: 2, level2Slots: 2 },
      { idDoor: 6, idRoom: 6, level1Slots: 3, level2Slots: 3 },
      { idDoor: 7, idRoom: 4, level1Slots: 3, level2Slots: 3 }
    ]
  },
  {
    idMap: 2,
    label: 'T Map',
    rooms: [
      { idRoom: 0, logoResolution: 4 },
      { idRoom: 1, logoResolution: 6 },
      { idRoom: 2, logoResolution: 0 },
      { idRoom: 3, logoResolution: 2 },
      { idRoom: 4, logoResolution: 6 },
      { idRoom: 5, logoResolution: 5 },
      { idRoom: 6, logoResolution: 6 },
      { idRoom: 7, logoResolution: 6 },
      { idRoom: 8, logoResolution: 4 }
    ],
    doors: [
      { idDoor: 0, idRoom: 0, level1Slots: 0, level2Slots: 4 },
      { idDoor: 1, idRoom: 1, level1Slots: 4, level2Slots: 4 },
      { idDoor: 2, idRoom: 2, level1Slots: 4, level2Slots: 4 },
      { idDoor: 3, idRoom: 3, level1Slots: 4, level2Slots: 4 },
      { idDoor: 4, idRoom: 4, level1Slots: 3, level2Slots: 3 },
      { idDoor: 5, idRoom: 5, level1Slots: 4, level2Slots: 4 },
      { idDoor: 6, idRoom: 4, level1Slots: 3, level2Slots: 3 },
      { idDoor: 7, idRoom: 7, level1Slots: 4, level2Slots: 4 }
    ]
  },
  {
    idMap: 3,
    label: 'Cross Map',
    rooms: [
      { idRoom: 0, logoResolution: 4 },
      { idRoom: 1, logoResolution: 1 },
      { idRoom: 2, logoResolution: 4 },
      { idRoom: 3, logoResolution: 5 },
      { idRoom: 4, logoResolution: 1 },
      { idRoom: 5, logoResolution: 6 },
      { idRoom: 6, logoResolution: 6 },
      { idRoom: 7, logoResolution: 6 },
      { idRoom: 8, logoResolution: 6 }
    ],
    doors: [
      { idDoor: 0, idRoom: 0, level1Slots: 0, level2Slots: 4 },
      { idDoor: 1, idRoom: 1, level1Slots: 4, level2Slots: 4 },
      { idDoor: 2, idRoom: 2, level1Slots: 2, level2Slots: 2 },
      { idDoor: 3, idRoom: 3, level1Slots: 4, level2Slots: 4 },
      { idDoor: 4, idRoom: 2, level1Slots: 3, level2Slots: 3 },
      { idDoor: 5, idRoom: 5, level1Slots: 4, level2Slots: 4 },
      { idDoor: 6, idRoom: 2, level1Slots: 4, level2Slots: 4 },
      { idDoor: 7, idRoom: 7, level1Slots: 4, level2Slots: 4 }
    ]
  },
  {
    idMap: 4,
    label: 'Hall Map',
    rooms: [
      { idRoom: 0, logoResolution: 4 },
      { idRoom: 1, logoResolution: 6 },
      { idRoom: 2, logoResolution: 6 },
      { idRoom: 3, logoResolution: 4 },
      { idRoom: 4, logoResolution: 5 },
      { idRoom: 5, logoResolution: 6 },
      { idRoom: 6, logoResolution: 6 },
      { idRoom: 7, logoResolution: 4 },
      { idRoom: 8, logoResolution: 4 }
    ],
    doors: [
      { idDoor: 0, idRoom: 0, level1Slots: 0, level2Slots: 4 },
      { idDoor: 1, idRoom: 1, level1Slots: 4, level2Slots: 4 },
      { idDoor: 2, idRoom: 2, level1Slots: 4, level2Slots: 4 },
      { idDoor: 3, idRoom: 3, level1Slots: 4, level2Slots: 4 },
      { idDoor: 4, idRoom: 4, level1Slots: 4, level2Slots: 4 },
      { idDoor: 5, idRoom: 5, level1Slots: 4, level2Slots: 4 },
      { idDoor: 6, idRoom: 6, level1Slots: 4, level2Slots: 4 },
      { idDoor: 7, idRoom: 7, level1Slots: 4, level2Slots: 4 }
    ]
  }
];

export const getTilMap = (idMap: number): TilMapDefinition | undefined =>
  TIL_MAPS.find((m) => m.idMap === idMap);

export const buildEmptyLock = (door: TilDoorDefinition): TilLock => {
  const isEntry = door.idDoor === 0;
  const level1: TilLockLevel = {
    LevelIndex: 1,
    listEnigmaPossible: isEntry
      ? []
      : new Array(door.level1Slots).fill(TIL_PUZZLE_EMPTY),
    ModuleCount: isEntry ? 0 : door.level1Slots
  };
  const level2: TilLockLevel = {
    LevelIndex: 2,
    listEnigmaPossible: new Array(door.level2Slots).fill(TIL_PUZZLE_EMPTY),
    ModuleCount: door.level2Slots
  };
  return { idLock: door.idDoor, lockSystem: [level1, level2] };
};

export const buildEmptyRooms = (idMap: number): Record<number, TilRoom> => {
  const map = getTilMap(idMap);
  if (!map) return {};
  return Object.fromEntries(
    map.rooms.map((r) => [
      r.idRoom,
      { idRoom: r.idRoom, TextToShow: '', URLPicture: '' }
    ])
  );
};

export const buildEmptyLocks = (idMap: number): Record<number, TilLock> => {
  const map = getTilMap(idMap);
  if (!map) return {};
  return Object.fromEntries(map.doors.map((d) => [d.idDoor, buildEmptyLock(d)]));
};

export const buildDefaultTilConfig = (idMap: number = 1): TilGameConfig => {
  const map = getTilMap(idMap);
  const rooms: TilRoom[] = map
    ? map.rooms.map((r) => ({
        idRoom: r.idRoom,
        TextToShow: '',
        URLPicture: ''
      }))
    : [];
  const locks: TilLock[] = map
    ? map.doors.map((d) => buildEmptyLock(d))
    : [];
  const now = new Date().toISOString();
  return {
    idConfig: uuid(),
    TemplateName: '',
    idMap,
    isDefaultConfig: false,
    DateCreation: now,
    DateModification: now,
    Version: 0,
    IDUser: '',
    rooms,
    locks
  };
};
